export * from './service/index.js'
export * from './utils/label-config-builder.js'
export * from './utils/task-transformer.js'
export * from './utils/annotation-exporter.js'
export {
  WebhookAction,
  WebhookPayload,
  WebhookHandler,
  registerWebhookHandler,
  unregisterWebhookHandler,
  clearWebhookHandlers
} from './route/webhook.js'

import './route.js'
import './route/webhook.js'

process.on('bootstrap-module-start' as any, async ({ app, config, client }: any) => {
  console.log('[integration-label-studio:bootstrap] Label Studio integration initialized with subdomain cookie-sharing SSO')
})
